<template>
  <el-select @change="onChange" v-model="status" placeholder="活动状态" clearable>
    <el-option
        v-for="item in STATUS_OPTION"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import {STATUS_OPTION} from "@/enums/gift";

export default {
  name: "status-option",
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.status = newVal
      }
    }
  },
  data() {
    return {
      status: undefined,
      STATUS_OPTION
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.status)
    }
  }
}
</script>

<style scoped>

</style>
